import React, { FunctionComponent } from 'react';

import { NBSP } from '@lt/components/constants/userflow';
import { formatDate } from '@lt/components/utils/date';
import { pluralizeTouristsCount } from '@lt/components/utils/pluralizeUtils';
import {
  useGetWhitelabelDomain,
  useGetBaseQueryParams,
  useGetRedirect,
} from '../../../../context/constructorContext';

import { createWidgetLink } from '../../../../utils/url';

// import { DirectionWidgetSiblings } from '../DirectionWidgetSiblings';
import {
  Title,
  Adults,
  Visa,
  Wrapper,
  Image,
  SearchParams,
  Kids,
  Link,
  FlightIcon,
  Price,
  MoonIcon,
} from './styles';
import { DirectionWidgetItemProps } from './types';

export const DirectionWidgetItem: FunctionComponent<DirectionWidgetItemProps> = (props) => {
  const {
    destinationName,
    image,
    link,
    visa,
    price,
    adults,
    start_date,
    nights,
    departureName,
    kids = [],
    description,
    // siblings_departures,
  } = props;

  const { visa_text, visa_type } = visa;
  const hasVisa = visa_type !== 'NO_VISA';

  const tourists = adults + kids.length;
  const touristsCountText = pluralizeTouristsCount(tourists);
  const date = formatDate(start_date, 'dd MMM');

  const whitelabelDomain = useGetWhitelabelDomain();
  const baseQueryParams = useGetBaseQueryParams();
  const redirect = useGetRedirect();

  const url = createWidgetLink(`${whitelabelDomain}${link}`, baseQueryParams);

  return (
    <Wrapper>
      <Image src={image} />
      <Link href={url} target={redirect}>
        <Title>{destinationName}</Title>
      </Link>
      <Visa hasVisa={hasVisa}>{visa_text}</Visa>
      <Link href={url} target={redirect}>
        <Price prefix={`от${NBSP}`} value={price} />
      </Link>

      <div>
        {[...Array(adults)].map((item = 0, index) => {
          const key = item + index;
          return <Adults key={key} />;
        })}
        {[...Array(kids.length)].map((item = 0, index) => {
          const key = item + index;
          return <Kids key={key} />;
        })}
        {NBSP}на {touristsCountText} с перелётом
      </div>
      <SearchParams>
        {date}, {nights}
        <MoonIcon /> · <FlightIcon />
        {departureName}
      </SearchParams>
      {description && <p>{description}</p>}
      {/* {siblings_departures && <DirectionWidgetSiblings items={siblings_departures} />} */}
    </Wrapper>
  );
};
